import React from "react";
import { AbilityDisplay, Bookmark, PlayingCard } from "../games/cardComponent";
import useWindowDimensions from "../../util/windowUtils";
import StaticCard from "../games/staticCard";
import useCardDimensions from "../../util/cardUtils";
import DraggableCard from "../games/zones/hand/draggableCard";
import { SCHOOL_COLORS } from "../../util/cardEffects/effectTypes";

export default function CardDemo() {
    const { height } = useWindowDimensions();
    const { cardHeight, cardWidth } = useCardDimensions();

    return <div style={{
        position: "relative",
        backgroundColor: "#555555",
        width: "100%",
        height: `${height - 56}px`,
        overflow: "hidden",
        zIndex: 0,
        padding: 0,
        margin: 0
    }}>

        {/* Just a card element */}

        <PlayingCard
            name={"Electromancer"}
            school={"Electric"}
            focus={7}
            castThreshold={3}
            cost={10}
            classCard={true}
            ritual={true}
            verticalIndex={0}
            cast={"deal 25 damage to target player"}
            play={"remove 3 focus from target spell an opponent controls"}
            scale={1}
            inline={true}
        />
        <PlayingCard
            name={"Electromancer"}
            school={"Electric"}
            focus={7}
            castThreshold={3}
            cost={10}
            classCard={true}
            ritual={true}
            verticalIndex={0}
            cast={"deal 25 damage to target player"}
            play={"remove 3 focus from target spell an opponent controls"}
            scale={1}
            inline={true}
        />
        <PlayingCard
            name={"Electromancer"}
            school={"Electric"}
            focus={7}
            castThreshold={3}
            cost={10}
            classCard={true}
            ritual={true}
            verticalIndex={0}
            cast={"deal 25 damage to target player"}
            play={"remove 3 focus from target spell an opponent controls"}
            scale={1}
            inline={true}
        />

        <StaticCard
            X={cardWidth * .25}
            Y={cardHeight * 1.25}
            rotation={-50}
        >
            <PlayingCard
                name={"Electromancer"}
                school={"Electric"}
                focus={5}
                tempFocus={2}
                castThreshold={3}
                cost={10}
                classCard={true}
                verticalIndex={0}
                cast={"deal 25 damage to target player"}
                play={"remove 3 focus from target spell an opponent controls"}
                scale={1}
            />
        </StaticCard>

        <DraggableCard
            initialX={cardWidth * 1.75}
            initialY={cardHeight * 1.25}
            initialRotation={50}
        >
            <PlayingCard
                name={"Flamethrower"}
                school={"Thermal"}
                focus={7}
                castThreshold={3}
                cost={10}
                verticalIndex={0}
                cast={"deal 25 damage to target player"}
                play={"remove 3 focus from target spell an opponent controls"}
                scale={1}
            />
        </DraggableCard>

        <StaticCard
            X={cardWidth * 5}
            Y={cardHeight * 1.25}
            rotation={0}
        >
            <Bookmark cost={6} focus={3} tempFocus={1} />
        </StaticCard>

        <StaticCard
            X={cardWidth * 1.75}
            Y={cardHeight * 1.25}
            rotation={0}
        >
            <AbilityDisplay text="Deal 15 Damage to target player" schoolColor={SCHOOL_COLORS["Manifest"]} abilityType={"play"} />
        </StaticCard>
    </div >
}